import { call, put, takeLatest } from 'redux-saga/effects';
import { 
    PRIOR_AUTH_SUBMISSION_DATA_REQUEST,
    PRIOR_AUTH_INSIGHTS_DATA_REQUEST,
    SERVICE_INTERACTIONS_CALLS_DATA_REQUEST,
    SERVICE_INTERACTIONS_SMART_EDITS_DATA_REQUEST,
    PCMS_DATA_REQUEST,
    POCA_DATA_REQUEST
} from '@src/middleware/actions/actionTypes';
import { setRequestError, setRequestLoading, setRequestSuccess } from '@src/middleware/actions/common/common.actions';
import { myInsightsStateKeys } from '@src/CommonComponents/constant/constant';
import { 
  getPriorAuthorizationSubmissionData, 
  getPriorAuthorizationSubmissionDataByChannel,
  getCallsSummaryData,
  getSmartEditsRepairedResubmittedShared,
  getPCMSData,
  getPOCAData
} from '@src/middleware/services/myInsights/myInsights.service';

const getServiceMethod = (key: string) => {
  switch (key) {
    case myInsightsStateKeys.priorAuthSubmissionData:
      return getPriorAuthorizationSubmissionData;
    case myInsightsStateKeys.priorAuthInsightsData:
      return getPriorAuthorizationSubmissionDataByChannel;
    case myInsightsStateKeys.serviceInteractionsCalls:
      return getCallsSummaryData;
    case myInsightsStateKeys.serviceInteractionsSmartEdits:
      return getSmartEditsRepairedResubmittedShared;
    case myInsightsStateKeys.pcmsData:
      return getPCMSData;
    case myInsightsStateKeys.pocaData:
      return getPOCAData;
    default:
      return getPriorAuthorizationSubmissionData;
  }
}

export function* fetchMyInsightsData(action: any) {
  const { key, payload } = action;
  const loadingKey = `${key}Loading`;
  const errorKey = `${key}Error`;

  try {
    yield put(setRequestError(false, errorKey));
    yield put(setRequestLoading(true, loadingKey));

    const response = yield call(getServiceMethod(key), payload);
    
    yield put(setRequestLoading(false, loadingKey));

    if (response?.Status !== 'OK') {
      yield put(setRequestError(true, errorKey));
    } else {
      yield put(setRequestSuccess(response?.Data, key));
    }
  } catch (error) {
    yield put(setRequestLoading(false, loadingKey));
    yield put(setRequestError(true, errorKey));
  }
}

export function* myInsightsSaga() {
  yield takeLatest(PRIOR_AUTH_SUBMISSION_DATA_REQUEST, fetchMyInsightsData);
  yield takeLatest(PRIOR_AUTH_INSIGHTS_DATA_REQUEST, fetchMyInsightsData);
  yield takeLatest(SERVICE_INTERACTIONS_CALLS_DATA_REQUEST, fetchMyInsightsData);
  yield takeLatest(SERVICE_INTERACTIONS_SMART_EDITS_DATA_REQUEST, fetchMyInsightsData);
  yield takeLatest(PCMS_DATA_REQUEST, fetchMyInsightsData);
  yield takeLatest(POCA_DATA_REQUEST, fetchMyInsightsData);
}

export default [myInsightsSaga];
